import React from 'react';
import LockIcon from 'hudl-react-kickoff/icons/Lock';

const UniformUiComponents = window.__uniformui_Components;

const PrivacyMessage = (props) => {
  return (
    <div className="tab-blank-state">
      <h1>{props.teamName}'s Highlights Are For Their Eyes Only</h1>
      <LockIcon className="lock-icon blank-icon"/>
      <p>
        {props.teamName} have their highlights set to private.
      </p>
      <p>
        Why don't you check out who's on the Team instead?
      </p>
      <br/>
      <UniformUiComponents.Button
        onClick={(e) => {
          e.preventDefault();
          this.props.onChangeTab('about');
        }}
        size="small"
        type="primary"
        text="Check Out The Team"
      />
    </div>
  );
};

PrivacyMessage.propTypes = {
  dispatch: React.PropTypes.func.isRequired,
  teamId: React.PropTypes.string.isRequired,
  teamName: React.PropTypes.string.isRequired,
  onChangeTab: React.PropTypes.func.isRequired,
};

export default PrivacyMessage;
